import { Component, OnInit } from '@angular/core';
import { User } from '../models/user';
import { AccountService } from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { OrderPipe } from 'ngx-order-pipe';
import { UserService } from '../services/user/user.service';
import { Address } from '../models/address';
import { ServiceProvider } from '../models/service-provider';
import { ServiceProviderService } from '../services/service-provider/service-provider.service';
import { Account } from '../models/account';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';



@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.css']
})
export class AdminUsersComponent implements OnInit {

  public userInfo: User = new User();
  isUserBelongsToAccount = false; isUserBelongsToProvider = false;
  showMultiSelect = false;
  listing: boolean = true; adminUserRoles = []; availableUserRoles = this.foruscareService.getUserRoles();
  confirmPassword: string; userEmailExists: boolean = false; userMobileExists: boolean = false;
  showPassword: boolean = false; emailExists: boolean = false; mobileExists: boolean = false; nameExists: boolean = false;

  public serviceProvidersBackup = [];
  public serviceProvidersDropdown = [];
  public providersList = [];

  public users: User[];
  totalRecords: number = 0;
  public accounts: Account[];
  public accountsList : any [];
  public serviceProviders: ServiceProvider[];
  showPasswordPolicy:Boolean = false;
  isStrongPassword:Boolean = false;
  dropdownSettings:any={};
  operationalAdminSelectionValidation:Boolean = true;
  selectedUserPhoneNumber = null;
  rows = 10;
  public paging = {currentPage:  0};// Pagination starting index
  private searchTerms = new Subject<any[]>();  // Subject to emit search terms
  results: any[] = [];  // Store search results
  
  constructor(public accountService: AccountService, public foruscareService: ForuscareService, public orderPipe: OrderPipe, public userService: UserService, public serviceProviderService: ServiceProviderService) {
    this.setupSearch();
  }

  order: string = 'name';
  reverse: boolean = false;
  emailPattern = "";
  dateFormatList :any[];
  ngOnInit() {
   this.dateFormatList = ["dd/MM/yyyy","dd/MMM/yyyy","MMM/dd/yyyy","MM/dd/yyyy","dd/MM/yyyy hh:mm tt","MMM/dd/yyyy hh:mm tt","dd/MMM/yyyy hh:mm tt","MM/dd/yyyy hh:mm tt","dd/MM/yyyy H:mm","dd/MMM/yyyy H:mm","MM/dd/yyyy H:mm","MMM/dd/yyyy H:mm",
                            "dd-MM-yyyy","dd-MMM-yyyy","MMM-dd-yyyy","MM-dd-yyyy","dd-MM-yyyy hh:mm tt","dd-MMM-yyyy hh:mm tt","MMM-dd-yyyy hh:mm tt","MM-dd-yyyy hh:mm tt","dd-MM-yyyy H:mm","dd-MMM-yyyy H:mm","MMM-dd-yyyy H:m","MM-dd-yyyy H:mm",
                            "yyyy/dd/MM","yyyy/dd/MMM","yyyy/MMM/dd","yyyy/MM/dd","yyyy/dd/MM hh:mm tt","yyyy/MMM/dd hh:mm tt","yyyy/dd/MMM hh:mm tt","yyyy/MM/dd hh:mm tt","yyyy/dd/MM H:mm","yyyy/dd/MMM H:mm","yyyy/MM/dd H:mm","yyyy/MMM/dd H:mm",
                            "yyyy-dd-MM","yyyy-dd-MMM","yyyy-MMM-dd","yyyy-MM-dd","yyyy-dd-MM hh:mm tt","yyyy-dd-MMM hh:mm tt","yyyy-MMM-dd hh:mm tt","yyyy-MM-dd hh:mm tt","yyyy-dd-MM H:mm","yyyy-dd-MMM H:mm","yyyy-MMM-dd H:m","yyyy-MM-dd H:mm"
                          ];
    // this.getExistingAdminUsers(0);
    this.getExistingAccounts();
    this.getExistingServiceProviders();
    //this.getExistingProvidersBasicInfo();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'itemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }

  getExistingServiceProviders() {
    this.serviceProvidersBackup = [];
    this.providersList = [];
    this.serviceProviderService.getAllProviders()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.serviceProvidersDropdown = response.data;
            this.serviceProvidersBackup = response.data;
            response.data.forEach(element => {
              this.providersList.push({ id: element.providerId, itemName: element.providerName });
            });
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }
  // getExistingProvidersBasicInfo() {
  //   this.serviceProvidersBackup = [];
  //   this.providersList = [];
  //   this.serviceProviderService.getExistingProviders()
  //     .subscribe(response => {
  //       if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
  //         if (response.data != null) {
  //           this.serviceProvidersBackup = response.data.response;
  //           response.data.response.forEach(element => {
  //             this.providersList.push({ id: element.id, itemName: element.name });
  //           });
  //         }
  //       }
  //       else {
  //         this.foruscareService.showNotification(response.message, "danger");
  //       }
  //     });
  // }

  rolesModified(selectedValue: any,selectionType:any) {
    this.operationalAdminSelectionValidation = true;
    if(selectionType=='selectedAll'){
      this.operationalAdminSelectionValidation = false;
    }
    else if(selectionType==null){
      if(this.adminUserRoles.length>1 && this.adminUserRoles.filter(function(t){return t.id=="ROLE_OPERATIONAL_ADMIN"}).length>0){
      this.operationalAdminSelectionValidation = false;
      }
      else{
        this.operationalAdminSelectionValidation = true;
      }
    }
    this.showMultiSelect = false;
    this.userInfo.dateFormat = null;
    this.userInfo.isLoginOTPRequired = null;
    if (this.adminUserRoles != null && this.adminUserRoles.length > 0) {
      // start : operational admin
      let operationalAdmin = null;
      for (let index = 0; index < this.adminUserRoles.length; index++) {
        if(this.adminUserRoles[index].id==this.foruscareService.ROLE_OPERATIONAL_ADMIN){
          if(selectionType=='selectedAll'){
            this.adminUserRoles.splice(index,1);
            this.foruscareService.showNotification("Operational Admin role can not be selected in Select All option", "warning");
            this.userInfo.accountId = null;
            this.userInfo.providerId = null;
          }
          else if (selectionType==null){
            operationalAdmin = this.adminUserRoles[index];
          }
        }
      }
      if(operationalAdmin!=null && selectionType==null){
        this.adminUserRoles.splice(0);
        this.adminUserRoles.push(operationalAdmin);
        this.foruscareService.showNotification("No other role can be selected with Operational Admin", "warning");
        this.showMultiSelect = true;
        this.userInfo.accountId = null;
        this.userInfo.providerId = null;
      }
      // end : operational admin
      let providerRoles = this.adminUserRoles.find(ob => ob['id'] == this.foruscareService.ROLE_OPTHALMOLOGY_SUPERVISOR || ob['id'] == this.foruscareService.ROLE_OPHTHALMOLOGY_EXPERT || ob['id'] == this.foruscareService.ROLE_SPECTACLE_ADMIN || ob['id'] == this.foruscareService.ROLE_OPERATIONAL_ADMIN);
      if (providerRoles != null) {
        this.isUserBelongsToProvider = true;
      }
      else {
        this.isUserBelongsToProvider = false;
        this.userInfo.providerId = null;
      }

      let accountRoles = this.adminUserRoles.find(ob => ob['id'] == this.foruscareService.ROLE_PROGRAM_LEAD || ob['id'] == this.foruscareService.ROLE_CLUSTER_LEAD || ob['id'] == this.foruscareService.ROLE_ORGANIZATION || ob['id'] == this.foruscareService.ROLE_OPERATIONAL_ADMIN || ob['id'] == this.foruscareService.ROLE_EYE_MITRA || ob['id'] == this.foruscareService.ROLE_EYE_CONNECT  || ob['id'] == this.foruscareService.ROLE_HOSPITAL_OPERATOR || ob['id'] == this.foruscareService.ROLE_QUALITY_OFFICER);
      if (accountRoles != null) {
        this.isUserBelongsToAccount = true;
      }
      else {
        this.isUserBelongsToAccount = false;
        this.userInfo.accountId = null;
      }
    }
    else {
      this.isUserBelongsToAccount = false; this.userInfo.accountId = null;
      this.isUserBelongsToProvider = false; this.userInfo.providerId = null;
    }
  }



  getExistingAccounts(): any {
    this.accounts = [];
    this.accountsList = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null && response.data.length > 0) {
            this.accounts = response.data;
            response.data.forEach(element => {
              this.accountsList.push({ id: element.accountId, itemName: element.accountName });
            });
            
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }
  offset = 0;
  onPageChange(event) {
    this.offset = event.first;
    this.rows = event.rows;
    this.paging.currentPage = event.first;
    this.getExistingAdminUsers(this.offset);
  }


  getExistingAdminUsers(offset) {
    let count = 10;
    this.users = [];
    this.userService.adminUsersSearch( this.searchData.term, this.searchData.searchby,count, offset)
      .subscribe(response => {
        if (response.status == 200 ) {
          if (response.data != null && response.data.response.length > 0) {
            this.users = response.data.response;
            this.totalRecords = response.data.totalCount;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  getUserRoleName(key: string) {
    if (key != null) {
      return this.foruscareService.getUserRolesArrayToString(key);
    }
  }

  getBelongsToForOpsAdmin(user){
    var result="";
    if(user.accountsMapped!=null && user.accountsMapped.length>0){
      var array = user.accountsMapped.split(",");
      for (let index = 0; index < array.length; index++) {
        if(index==0){
          result = result + this.getAccountName(array[index]);
        }
        else{
          result = result + ", "+this.getAccountName(array[index]);
        }
      }
    }
    if(user.providersMapped!=null && user.providersMapped.length>0){
      var array = user.providersMapped.split(",");
      for (let index = 0; index < array.length; index++) {
        if(index==0 && result.length==0){
          result = result + this.getProviderName(array[index]);
        }
        else{
          result = result + ", "+this.getProviderName(array[index]);
        }
      }
    }
    return result;
  }

  getAccountName(accountId) {
    if (accountId > 0) {
      let accounInfo = this.accounts.find(ob => ob["accountId"] == accountId);
      if (accounInfo != null)
        return accounInfo.accountName;
      else
        return "N/A";
    }
    else {
      return "";
    }
  }

  getProviderName(providerId) {
    if (providerId > 0) {
      let providerInfo = this.serviceProvidersBackup.find(ob => ob["providerId"] == providerId);
      if (providerInfo != null)
        return providerInfo.providerName;
      else
        return "N/A";
    }
    else {
      return "";
    }
  }

  providerNameValidation(providerName) {
    if (providerName && providerName.length > 0) {
        return providerName;
    }
    else {
      return 'NA';
    }
  }


  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    this.order = value;
  }

  public currentPage: number = 1;
  getSerialNumber(indexval) {
    return (this.paging.currentPage * 10 - 10) + indexval;
  }

  updateBelongsTo(roleName) {
    this.serviceProviders = [];
    this.userInfo.accountId = null;
    this.userInfo.providerId = null;
    if (roleName == this.foruscareService.ROLE_SPECTACLE_ADMIN) {
      this.serviceProviders = this.serviceProvidersBackup.filter(ob => ob['type'] == this.foruscareService.SERVICE_SPECTACLE);
    }
    else if (roleName == this.foruscareService.ROLE_OPTHALMOLOGY_SUPERVISOR) {
      this.serviceProviders = this.serviceProvidersBackup.filter(ob => ob['type'] == this.foruscareService.SERVICE_READING_CENTER || ob['type'] == this.foruscareService.SERVICE_TELE_REFRACTION);
    }
  }

  toggleView() {
    this.listing = !this.listing;
    this.confirmPassword = null;
    this.userInfo = new User();
    this.userInfo.roleName = this.foruscareService.ROLE_PROGRAM_LEAD;
    this.adminUserRoles = [];
    this.isUserBelongsToAccount=false,
    this.isUserBelongsToProvider=false;
    this.showPasswordPolicy = false;
    this.isStrongPassword = false;
    if (this.listing) {
      this.searchData.term = "";
        this.searchData.searchby = "";
       this.getExistingAdminUsers(0);
       this.selectedUserPhoneNumber = null; 
    };
  }

  getUserInfo(userId) {
    this.adminUserRoles = [];
    this.userService.getUserInfoById(userId)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.gender == "MALE") {
              response.data.gender = "Male";
            }
            if (response.data.gender == "FEMALE") {
              response.data.gender = "Female";
            }
            // this.userInfo = response.data;
            if (response.data != null) {
              if (response.data.roleName != null) {
                let userrolesArray = response.data.roleName.split(",");
                if (userrolesArray != null && userrolesArray.length > 0) {
                  userrolesArray.forEach(roleName => {
                    if (roleName != null && roleName.trim().length > 0) {
                      this.adminUserRoles.push({
                        id: roleName,
                        itemName: this.foruscareService.getRoleNameUsingKey(roleName)
                      });
                    }
                  });
                }
                if (response.data.roleName.indexOf(this.foruscareService.ROLE_CLUSTER_LEAD) >= 0 || response.data.roleName.indexOf(this.foruscareService.ROLE_ORGANIZATION) >= 0 || response.data.roleName.indexOf(this.foruscareService.ROLE_PROGRAM_LEAD) >= 0 || response.data.roleName.indexOf(this.foruscareService.ROLE_EYE_MITRA) >= 0 || response.data.roleName.indexOf(this.foruscareService.ROLE_EYE_CONNECT) >= 0) {
                  this.isUserBelongsToAccount = true;
                }
                if (response.data.roleName.indexOf(this.foruscareService.ROLE_OPTHALMOLOGY_SUPERVISOR) >= 0 || response.data.roleName.indexOf(this.foruscareService.ROLE_OPHTHALMOLOGY_EXPERT) >= 0 || response.data.roleName.indexOf(this.foruscareService.ROLE_SPECTACLE_ADMIN) >= 0) {
                  this.isUserBelongsToProvider = true;
                }
                if(response.data.roleName.indexOf(this.foruscareService.ROLE_OPERATIONAL_ADMIN) >= 0){
                  this.isUserBelongsToProvider = true;
                  this.isUserBelongsToAccount = true;
                  this.showMultiSelect = true;
                  if(response.data.accountsMapped!=null && response.data.accountsMapped.length>0){
                    response.data.accountsMapped.split(',').forEach(element1 => {                      
                      this.accounts.forEach(element2 => {
                        if(element1 == element2.accountId){
                          if(response.data.accountId == null ){
                          response.data.accountId=[];
                          }
                          response.data.accountId.push({id:element2.accountId,itemName:element2.accountName});
                        }
                      });
                    });
                    }
                    else{
                      response.data.accountId = null;
                    }
                    if(response.data.providersMapped!=null && response.data.providersMapped.length>0){
                      console.log(this.serviceProvidersBackup)
                      response.data.providersMapped.split(',').forEach(element1 => {                        
                        this.serviceProvidersBackup.forEach(element2 => {
                          if(element1 == element2.providerId){
                            if(response.data.providerId == null ){
                              response.data.providerId=[];
                              }
                            response.data.providerId.push({id:element2.providerId,itemName:element2.providerName});
                          }
                        });
                      });
                      }
                      else{
                        response.data.providerId = null;
                      }
                }
              }
                
            }
            
            this.userInfo = response.data;
            this.selectedUserPhoneNumber = this.userInfo?.phoneNo;
            this.listing = false;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  addupdateUser() {
    if(!this.operationalAdminSelectionValidation){
      this.foruscareService.showNotification("No other role can be selected with Operational Admin", "warning");
      return;
    }
    if (this.userInfo!=null && this.userInfo.password!=null && !this.checkStrongPassword(this.userInfo.password)) {
      this.foruscareService.showNotification("Please fill the strong password as per the password policy","danger");
      return;
    }
    if (this.adminUserRoles == null || this.adminUserRoles.length == 0) {
      this.foruscareService.showNotification("Please select user role to create the user.", "danger");
      return;
    }
    if (this.userMobileExists) {
      this.foruscareService.showNotification("Mobile number already exists. Please enter a different number.", "danger");
      return;
    }
    else {
      this.userInfo.roleName = "";
      this.adminUserRoles.forEach(role => {
        if (this.userInfo.roleName != null && this.userInfo.roleName.trim().length > 0)
          this.userInfo.roleName = this.userInfo.roleName + ",";
        if (role['id'] != null)
          this.userInfo.roleName = this.userInfo.roleName + role['id'];
      })
    }
    if (this.isUserBelongsToAccount) {
      if (this.userInfo.accountId == null || this.userInfo.accountId.length == 0) {
        this.foruscareService.showNotification("Please select the Account to associate the user.", "danger");
        return;
      }
      else{
        if (this.userInfo.roleName.indexOf(this.foruscareService.ROLE_OPERATIONAL_ADMIN)>-1){
        for (let index = 0; index < this.userInfo.accountId.length; index++) {
          if(index==0)
            this.userInfo.accountsMapped = this.userInfo.accountId[index].id;
          else
          this.userInfo.accountsMapped = this.userInfo.accountsMapped+ ','+this.userInfo.accountId[index].id ;
        }
        this.userInfo.accountId = null;
        }
        else{
          this.userInfo.accountsMapped = null;
          this.userInfo.providersMapped = null;
        }
    }
    }
    else {
      this.userInfo.accountId = null;
    }
    if (this.isUserBelongsToProvider) {
      if (this.userInfo.providerId == null) {
        this.foruscareService.showNotification("Please select the Provider to associate the user.", "danger");
        return;
      }
      else{
        if (this.userInfo.roleName.indexOf(this.foruscareService.ROLE_OPERATIONAL_ADMIN)>-1){
        for (let index = 0; index < this.userInfo.providerId.length; index++) {
          if(index==0)
            this.userInfo.providersMapped = this.userInfo.providerId[index].id;
          else
          this.userInfo.providersMapped = this.userInfo.providersMapped+ ',' +this.userInfo.providerId[index].id;
        }
        this.userInfo.providerId = null;
      }
      else{
        this.userInfo.accountsMapped = null;
        this.userInfo.providersMapped = null;
      }
      }
    }
    else {
      this.userInfo.providerId = null;
    }
    if (this.userInfo["userId"] != null) {
      this.userService.updateUser(this.userInfo, this.userInfo["userId"])
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            //if (response.data != null) {
              this.foruscareService.showNotification("User info updated successfully.", "success");
              this.toggleView();
            //}
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    } else {
      this.userService.createUser(this.userInfo)
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            //if (response.data != null) {
              this.foruscareService.showNotification("User created successfully.", "success");
              this.toggleView();
            //}
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    }
  }

  editUserInfo(userInfo: User) {
    if (userInfo != null) {
      this.getUserInfo(userInfo["userId"]);
      // this.userInfo = userInfo;
    }
  }

  getAddressString(address: Address): string {
    return this.foruscareService.getAddressString(address);
  }

  convertUTCToLocal(utcString) {
    return this.foruscareService.convertUTCtoLocal(utcString);
  }

  userEmailValidationService = null; userMobileValidationService = null;
  validateUserEmailExists(accountInfoForm) {
    if (accountInfoForm != null && accountInfoForm.form != null && accountInfoForm.form.controls != null && accountInfoForm.form.controls.userEmail != null && accountInfoForm.form.controls.userEmail.status == "INVALID")
      return;
    if (this.userEmailValidationService != null) {
      this.userEmailValidationService.unsubscribe();
    }
    this.userEmailValidationService = this.userService.checkEmailExists(this.userInfo.email)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null && response.data.userEmailExists) {
            this.userEmailExists = true;
          }
          else this.userEmailExists = false;
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  validateUserMobileExists() {
    this.userMobileExists = false;
    if ((this.userInfo != null && this.userInfo.phoneNo != null && this.userInfo.phoneNo.trim().length < 6) || (this.userInfo.phoneNo == this.selectedUserPhoneNumber))
      return;
    if (this.userMobileValidationService != null) {
      this.userMobileValidationService.unsubscribe();
    }
    this.userMobileValidationService = this.userService.checkMobileExists(this.userInfo.phoneNo)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null && response.data.userPhoneNumberExists) {
            this.userMobileExists = true;
          }
          else this.userMobileExists = false;
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  _keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  addNewAccount() {
    this.userInfo = new User();
    this.confirmPassword = null;
    this.adminUserRoles = [];
    this.userInfo = new User();
  }
  /*start : check strong password */
  checkStrongPassword(password){
    return this.foruscareService.verifyPasswordStrength(password);
  }
  /*end : check strong password */

  setupSearch(): void {
    this.users = [];
    let count = 10
    this.searchTerms.pipe(
      debounceTime(300),                // Wait for 300ms after the user stops typing
      distinctUntilChanged(),           // Only call the API if the term has changed
      switchMap(
        (term: any) => {
          return (this.userService.adminUsersSearch(term[0],term[1],count, this.offset))
        })  // Switch to the new search term
      ).subscribe(response => {
          if (response.data != null && response.data.response.length > 0) {
            this.users = response.data.response;
            this.totalRecords = response.data.totalCount;
          }else{
            this.users = [];
          }
              // Update the results after the API call
      });
  }
  searchData = {
    term:'',
    searchby:''
  }
  // Method triggered when typing in the search box
  onSearch(term: string, searchby:string): void {
    this.offset = 0;
    this.users = [];
    this.paging.currentPage = 0;
    this.searchData = {
      term:term,
      searchby:searchby
    } 
    this.searchTerms.next([term,searchby]);  // Push the search term into the observable stream
  }

 


}

